import script from "./DisplayHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplayHeader.vue?vue&type=script&setup=true&lang=js"

import "./DisplayHeader.vue?vue&type=style&index=0&id=0181069a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0181069a"]])

export default __exports__